// analytics global is defined by script snippet included in main app html file (app.pug)

import exenv from 'exenv';
import invariant from 'invariant';


const check = (methodName: string) => {
  invariant(
    exenv.canUseDOM,
    `Cannot call tracking/analytics method ${methodName} outside browser environment`,
  );
  return Boolean(window.analytics);
};

const _analytics = {
  identify(...args: any) {
    if (check('identity')) {
      // @ts-expect-error - TS2339 - Property 'analytics' does not exist on type 'Window & typeof globalThis'.
      window.analytics.identify(...args);
    }
  },

  track(...args: any) {
    if (check('track')) {
      // @ts-expect-error - TS2339 - Property 'analytics' does not exist on type 'Window & typeof globalThis'.
      window.analytics.track(...args);
    }
  },
} as const;

export default _analytics;
